<template>
	<div id="app">
		<ChangePasswordPage v-if="showChangePasswordPage" />
		<ContentPage v-if="showContentPage" />
		<ForgotPasswordPage v-if="showForgotPasswordPage" />
		<LoginPage v-if="showLoginPage" />
		<Loading />
		<Confirmation />
		<Toasts />
	</div>
</template>

<script>
	import ChangePasswordPage from "./components/ChangePasswordPage"
	import ContentPage from "./components/ContentPage"
	import ForgotPasswordPage from "./components/ForgotPasswordPage"
	import LoginPage from "./components/LoginPage"
	import Loading from "./components/partials/Loading"
	import Confirmation from "./components/partials/Confirmation.vue"
	import Toasts from "./components/partials/Toasts.vue"
	import moment from "moment"

	export default {
		name: "app",
		components: {
			ChangePasswordPage,
			ContentPage,
			ForgotPasswordPage,
			LoginPage,
			Loading,
			Confirmation,
			Toasts
		},
		mounted: function () {
			window.onerror = function (errorMsg, url, lineNumber, columnNo, error) {
				try {
					errorMsg += " " + error.stack;
				}
				catch {}

				try {
					this.$store.dispatch("MopaneApi/logError", lineNumber + ": " + errorMsg + ". " + url)
				} catch {}
			}

			this.$store.commit("Shifts/setDate", moment().startOf("isoweek").toDate())
		},
		destroyed: function () {
			this.$store.commit("Intervals/clear", "AppRefreshData")
		},
		watch: {
			isLoggedIn: {
				immediate: true,
				handler(newValue, oldValue) {
					this.getData()
				}
			}
		},
		computed: {
			profile() { return this.$store.state.Profile.profile },
			isLoggedIn() {
				return (this.$store.state.Profile != null
					&& this.$store.state.Profile.isLoggedIn)
					|| (localStorage.isLoggedIn != null
						&& localStorage.isLoggedIn == "true")
			},
			isEmployee() { return this.profile.accounttype == 2 },
			showChangePasswordPage() { return this.$store.state.Pages.page == "ChangePasswordPage" },
			showContentPage() { return this.$store.state.Pages.page == "ContentPage" },
			showForgotPasswordPage() { return this.$store.state.Pages.page == "ForgotPasswordPage" },
			showLoginPage() { return this.$store.state.Pages.page == "LoginPage" }
		},
		methods: {
			getData: function () {
				var $this = this

				this.$store.dispatch("MopaneApi/createInstance").then(function () {
					if ($this.isLoggedIn) {
						$this.$store.commit("Profile/login")
						$this.$store.commit("Profile/setProfile", JSON.parse(localStorage.profile))

						$this.refreshData()
						$this.$store.dispatch("Intervals/set", { name: "AppRefreshData", callback: $this.refreshData, timeout: 900000 })

						$this.$store.dispatch("Alerts/getAlerts")

						if ($this.$store.state.Accounts.accounts.length < 1)
							$this.$store.dispatch("Accounts/getAccounts")

						if ($this.$store.state.ServiceTypeCategories.serviceTypeCategories.length < 1)
							$this.$store.dispatch("ServiceTypeCategories/getServiceTypeCategories")

						if ($this.$store.state.Shifts.cancellationPolicies.length < 1)
							$this.$store.dispatch("Shifts/getCancellationPolicies")

						if ($this.$store.state.Shifts.cancellationReasons.length < 1)
							$this.$store.dispatch("Shifts/getCancellationReasons")

						if ($this.$store.state.Leave.leaveStatuses.length < 1)
							$this.$store.dispatch("Leave/getLeaveStatuses")

						if ($this.$store.state.Leave.leaveTypes.length < 1)
							$this.$store.dispatch("Leave/getLeaveTypes")

						if ($this.$store.state.Incidents.types.length < 1)
							$this.$store.dispatch("Incidents/getIncidentTypes")

						if ($this.$store.state.Incidents.severities.length < 1)
							$this.$store.dispatch("Incidents/getIncidentSeverity")

						if ($this.$store.state.Incidents.statuses.length < 1)
							$this.$store.dispatch("Incidents/getIncidentStatuses")

						if ($this.$store.state.Vehicles.vehicles.length < 1)
							$this.$store.dispatch("Vehicles/getVehicles")

						if ($this.isEmployee) {
							$this.$store.dispatch("Customers/getCustomers")
						}
						else {
							$this.$store.dispatch("Funding/getPmFundingBalances")

							if ($this.$store.state.Invoices.invoiceStatuses.length < 1)
								$this.$store.dispatch("Invoices/getInvoiceStatuses")
						}

						$this.$store.dispatch("Pages/show", "ContentPage")
					}
					else {
						$this.$store.commit("Intervals/clear", "AppRefreshData")
						$this.$store.dispatch("Profile/logout")
					}

				})
			},
			refreshData: function () {
				this.$store.dispatch("Notifications/getNotifications")
				this.$store.dispatch("Shifts/getAvailableShifts")
			}
		}
	}
</script>

<style>
	html {
		top: 0;
		bottom: 0;
	}

	body {
		height: 100% !important;
	}

	[disabled],
	[disabled] input,
	[disabled] textarea,
	[disabled] select,
	[disabled] label,
	[disabled] a,
	[disabled] button {
		cursor: not-allowed !important;
		background-color: #fafafa !important;
	}

	.disabled,
	.disabled * {
		filter: grayscale(100%) !important;
		cursor: not-allowed !important;
	}

	label {
		white-space: nowrap;
	}

		label.required::after {
			content: "*";
			color: #dc3545;
			font-size: 18px;
			font-weight: bold;
		}

	#app {
		height: 100% !important;
	}

	.page {
		height: 100% !important;
		width: 100% !important;
		padding: 0 !important;
	}

	select {
		width: 100% !important;
		height: 50px !important;
		padding: 12px 37px 12px 18px !important;
		color: #081E4A !important;
		border: solid 1px #E0E5EE !important;
		border-radius: 40px !important;
		-moz-appearance: none !important;
		-webkit-appearance: none !important;
		appearance: none !important;
		background: rgba(255,255,255,1) url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>") no-repeat scroll right center/47px 37px !important;
		cursor: pointer;
	}

		select option {
			display: block;
			color: #E94A79;
			font-size: 16px;
			font-weight: 500;
			padding: 13px 12px;
		}

			select option[selected] {
				background: rgba(233,74,121,0.1);
				outline: none;
			}

	.scaled70 {
		transform: scale(0.7);
	}

	.btn-select {
		width: 100% !important;
		height: 100% !important;
		background-color: #ECEFF5 !important;
		border: solid 1px #CBD3E4 !important;
		font-size: 18px !important;
		padding: 0.5vmax 35px !important;
	}

		.btn-select option {
			width: auto !important;
			height: auto !important;
			background-color: #ffffff !important;
			border: solid 1px #CBD3E4 !important;
		}

	.mh-middle-container .btn-select {
		padding: 10px 35px !important;
	}

	.btn.btn-primary {
		border-radius: 30px;
		color: white;
		background: #E94A79;
		font-size: 18px;
		padding: 17px 30px;
		border-color: #E94A79;
		font-weight: 400;
		transition: all 0.3s ease-in-out
	}

	@media (prefers-reduced-motion: reduce) {
		.btn.btn-primary {
			transition: none
		}
	}

	@media (max-width: 1366px) {
		.btn.btn-primary {
			font-size: 16px;
			padding: 13px 25px
		}
	}

	.btn.btn-primary:not([disabled]):hover {
		background: white;
		color: #E94A79
	}

	.btn.btn-default.btn-green {
		background: #5ABA47;
		border-color: #5ABA47;
	}

		.btn.btn-default.btn-green:not([disabled]):hover {
			color: #5ABA47;
			background: white
		}

	.btn.btn-default.btn-red {
		background: #dc3545;
		border-color: #dc3545;
	}

		.btn.btn-default.btn-red:not([disabled]):hover {
			color: #dc3545;
			background: white
		}

	.btn.btn-primary {
		background: #5ABA47;
		border-color: #5ABA47;
	}

		.btn.btn-primary:not([disabled]):hover {
			color: #5ABA47;
			background: white
		}

	.round-icon-button {
		display: inline-block;
		width: 50px;
		height: 50px;
		background-color: #ECEFF5;
		border-radius: 50%;
		text-align: center;
		line-height: 50px;
		font-size: 19px;
		cursor: pointer;
	}

	.scroll-bar::-webkit-scrollbar {
		width: 15px;
	}

	.scroll-bar::-webkit-scrollbar-track {
		background: #f6f5f5;
		border-radius: 15px;
	}

	.scroll-bar::-webkit-scrollbar-thumb {
		background: #b0b0b0;
		border: solid 3px #e6e6e6;
		border-radius: 7px;
		border-radius: 15px;
	}

		.scroll-bar::-webkit-scrollbar-thumb:hover {
			background: #969494;
		}

	.row {
		width: 100% !important;
	}

	.table-curved > :first-child > :first-child > :first-child {
		border-radius: 15px 0 0 0;
	}

	.table-curved > :first-child > :first-child > :last-child {
		border-radius: 0 15px 0 0;
	}

	.table-curved > :last-child > :last-child > :first-child {
		border-radius: 0 0 0 15px;
	}

	.table-curved > :last-child > :last-child > :last-child {
		border-radius: 0 0 15px 0;
	}

	.data-table-table .column {
		z-index: 9;
	}

	.dataTables_wrapper .data-table {
		grid-template-areas:
			"perPage search search search"
			"table table table table"
			"pagination pagination pagination pagination";
	}

	@media (max-width: 1024px) {
		.dataTables_wrapper .data-table .data-table-table {
			height: calc(100vh - 510px) !important;
		}
	}

	@media (min-width: 1024px) {
		.dataTables_wrapper .data-table .data-table-table {
			height: calc(100vh - 348px) !important;
		}
	}

		.dataTables_wrapper .data-table .data-table-table {
			width: calc(100% );
			max-width: unset !important;
			margin-top: 0 !important;
			border-collapse: separate;
			border: solid 1px #ECEFF5;
			border-radius: 15px;
		}

			.dataTables_wrapper .data-table .data-table-table::-webkit-scrollbar {
				width: 15px;
			}

			.dataTables_wrapper .data-table .data-table-table::-webkit-scrollbar-track {
				background: #f6f5f5;
				border-radius: 15px;
			}

			.dataTables_wrapper .data-table .data-table-table::-webkit-scrollbar-thumb {
				background: #b0b0b0;
				border: solid 3px #e6e6e6;
				border-radius: 7px;
				border-radius: 15px;
			}

				.dataTables_wrapper .data-table .data-table-table::-webkit-scrollbar-thumb:hover {
					background: #969494;
				}

			.dataTables_wrapper .data-table .data-table-table .table {
			}

			.dataTables_wrapper .data-table .data-table-table .action-column.sortable:hover,
			.dataTables_wrapper .data-table .data-table-table .column.sortable:hover {
				color: #212529 !important;
			}

			.dataTables_wrapper .data-table .data-table-table table.dataTable > th,
			.dataTables_wrapper .data-table .data-table-table table.dataTable > td {
				line-height: 10px !important;
			}

			.dataTables_wrapper .data-table .data-table-table .action-column, .dataTables_wrapper .data-table .data-table-table .column {
				box-shadow: none !important;
				line-height: 25px;
			}

		.dataTables_wrapper .data-table .data-table-pagination input {
			width: 100px !important;
			height: 54px;
			border: solid 1px #E0E5EE !important;
			padding: 15px 15px 15px 15px !important;
			color: #7F92B8;
			font-weight: 500;
			margin: 0 10px 0 0 !important;
			-webkit-transition: all 0.3s ease-in-out;
			transition: all 0.3s ease-in-out;
			border-radius: 30px;
			text-align: center;
		}

		.dataTables_wrapper .data-table .data-table-pagination .pagination {
			overflow: visible;
		}

			.dataTables_wrapper .data-table .data-table-pagination .pagination .page-item .page-link {
				padding: 20px;
				text-align: center;
			}

			.dataTables_wrapper .data-table .data-table-pagination .pagination .page-item:not(.disabled) .page-link {
				color: #212529;
			}

			.dataTables_wrapper .data-table .data-table-pagination .pagination .page-item.active .page-link {
				background-color: #5ABA47;
				color: #ffffff;
			}

			.dataTables_wrapper .data-table .data-table-pagination .pagination .page-item:not(:first-child) .page-link,
			.dataTables_wrapper .data-table .data-table-pagination .pagination .page-item:not(:last-child) .page-link {
				min-width: 60px;
			}

			.dataTables_wrapper .data-table .data-table-pagination .pagination .page-item:first-child .page-link {
				border-top-left-radius: 30px;
				border-bottom-left-radius: 30px;
			}

			.dataTables_wrapper .data-table .data-table-pagination .pagination .page-item:last-child .page-link {
				border-top-right-radius: 30px;
				border-bottom-right-radius: 30px;
			}


		.mh-off-middle textarea {
			border: solid 1px #E0E5EE !important;
			border-radius: 27px
		}

		.mh-off-middle .mh-datepicker,
		.mh-off-middle .mh-timepicker,
		.mh-off-middle .field-with-icon {
			position: relative;
			width: 100%;
		}

		.mh-off-middle i,
		.mh-off-middle svg {
			position: absolute;
			display: block;
			right: 9px;
			top: 50%;
			transform: translate(0, -50%);
			color: #7F92B8;
			z-index: 3;
		}

			.mh-off-middle i.mh-icon-search {
				right: 19px;
			}

			.mh-off-middle i.action,
			.mh-off-middle i.action {
				cursor: pointer;
				color: #000000 !important;
			}

		.mh-off-middle input[type="text"], .mh-off-middle input[type="number"], .mh-off-middle input[type="email"], .mh-off-middle input[type="password"], .mh-off-middle select {
			height: auto !important;
		}

		.mh-off-middle select {
			padding: 15px !important;
		}

		.mh-off-middle textarea {
			height: 120px !important;
		}

		.mh-off-middle input[type="checkbox"] {
			position: absolute;
			opacity: 0 !important;
		}

			.mh-off-middle input[type="checkbox"] + label {
				position: relative;
				cursor: pointer;
				padding: 0;
				margin-left: 20px;
			}

				.mh-off-middle input[type="checkbox"] + label:before {
					content: '';
					margin-right: 10px;
					display: inline-block;
					position: absolute;
					left: -21px;
					top: 6px;
					width: 18px;
					height: 18px;
					background-color: #eceff5 !important;
					border: none;
					border-radius: 7px;
					margin-top: -3px;
				}

			.mh-off-middle input[type="checkbox"]:checked + label:after {
				content: '\57';
				font-family: "mopane";
				display: inline-block;
				font-size: 8px;
				color: White;
				position: absolute;
				left: -21px;
				top: 6px;
				width: 18px;
				height: 18px;
				background-image: none !important;
				background-color: #E94A79 !important;
				border-radius: 7px;
				margin-top: -3px;
				text-align: center;
				line-height: 17px
			}

		.mh-off-middle [class^="mh-icon-"] {
			line-height: 38px !important;
		}

		.mh-off-middle .mh-icon-calendar {
			line-height: 30px !important;
		}

		.mh-off-middle .mh-entries-status [class^="mh-icon-"] {
			line-height: 30px !important;
		}

		.card.mh-card.floating {
			position: fixed;
			top: 25%;
			right: 0;
			width: 91vw;
			border: 0px;
			background: #FFFFFF;
			box-shadow: 0px 0px 50px rgba(29,51,96,0);
			border-radius: 25px;
			height: auto;
			margin-bottom: 50px;
			padding: 0px;
			transform: translate(-5%, 0);
			max-height: calc(100vh - 25%);
		}

			.card.mh-card.floating .card-body {
				padding: 5px 5px;
				overflow-y: auto;
			}

			.card.mh-card.floating .card-header {
				padding: 5px 10px;
			}
</style>

